_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[54],{

/***/ "6+s+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_objectDestructuringEmpty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hGi/");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7vrA");
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Ogzj");
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Fl18");









var TermsOfService = function TermsOfService(_ref) {
  Object(_babel_runtime_helpers_esm_objectDestructuringEmpty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref);

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsxs"])(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["Fragment"], {
    children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_components_Header__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], {}), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("div", {
      style: {
        flex: 1
      },
      children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsxs"])(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
        children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("a", {
          href: "https://www.iubenda.com/terms-and-conditions/47469543",
          className: "iubenda-nostyle no-brand iubenda-embed iub-body-embed",
          title: "Terms and Conditions"
        }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: '(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);'
          }
        })]
      })
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_components_Footer__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (TermsOfService);

/***/ }),

/***/ "Fl18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/commonjs/index.js
var commonjs = __webpack_require__("yLev");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__("7vrA");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("zLVn");

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 6 modules
var Dropdown = __webpack_require__("97+O");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/DropdownToggle.js
var DropdownToggle = __webpack_require__("4OCD");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/DropdownMenu.js + 1 modules
var DropdownMenu = __webpack_require__("rSmC");

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/DropdownButton.js







var propTypes = {
  /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: prop_types_default.a.any,

  /** An `href` passed to the Toggle component */
  href: prop_types_default.a.string,

  /** An `onClick` handler passed to the Toggle component */
  onClick: prop_types_default.a.func,

  /** The content of the non-toggle Button.  */
  title: prop_types_default.a.node.isRequired,

  /** Disables both Buttons  */
  disabled: prop_types_default.a.bool,

  /**
   * Aligns the dropdown menu responsively.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"left"|"right"|{ sm: "left"|"right" }|{ md: "left"|"right" }|{ lg: "left"|"right" }|{ xl: "left"|"right"} }
   */
  menuAlign: DropdownMenu["a" /* alignPropType */],

  /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */
  menuRole: prop_types_default.a.string,

  /** Whether to render the dropdown menu in the DOM before the first time it is shown */
  renderMenuOnMount: prop_types_default.a.bool,

  /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */
  rootCloseEvent: prop_types_default.a.string,

  /** @ignore */
  bsPrefix: prop_types_default.a.string,

  /** @ignore */
  variant: prop_types_default.a.string,

  /** @ignore */
  size: prop_types_default.a.string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`.
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu related props are passed to the `Dropdown.Menu`
 */

var DropdownButton = react_default.a.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      rootCloseEvent = _ref.rootCloseEvent,
      variant = _ref.variant,
      size = _ref.size,
      menuAlign = _ref.menuAlign,
      menuRole = _ref.menuRole,
      renderMenuOnMount = _ref.renderMenuOnMount,
      disabled = _ref.disabled,
      href = _ref.href,
      id = _ref.id,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuAlign", "menuRole", "renderMenuOnMount", "disabled", "href", "id"]);

  return /*#__PURE__*/react_default.a.createElement(Dropdown["a" /* default */], Object(esm_extends["a" /* default */])({
    ref: ref
  }, props), /*#__PURE__*/react_default.a.createElement(DropdownToggle["a" /* default */], {
    id: id,
    href: href,
    size: size,
    variant: variant,
    disabled: disabled,
    childBsPrefix: bsPrefix
  }, title), /*#__PURE__*/react_default.a.createElement(DropdownMenu["b" /* default */], {
    align: menuAlign,
    role: menuRole,
    renderOnMount: renderMenuOnMount,
    rootCloseEvent: rootCloseEvent
  }, children));
});
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = propTypes;
/* harmony default export */ var esm_DropdownButton = (DropdownButton);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__("IP2g");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var fontawesome_svg_core_index_es = __webpack_require__("7O5W");

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var pro_solid_svg_icons_index_es = __webpack_require__("4Bjl");

// EXTERNAL MODULE: ./share/language.js
var share_language = __webpack_require__("1kOT");

// EXTERNAL MODULE: ./share/routes.js
var routes = __webpack_require__("85xM");

// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__("k7Sn");

// EXTERNAL MODULE: ./components/Footer/footer.scss
var footer = __webpack_require__("mLyT");

// CONCATENATED MODULE: ./components/Footer/index.js













fontawesome_svg_core_index_es["b" /* library */].add(pro_solid_svg_icons_index_es["g" /* faHeart */]);

var Footer_LangItem = function LangItem(_ref) {
  var locale = _ref.locale,
      t = _ref.t;
  return /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
      className: "set-language",
      "data-lang": locale,
      href: "?locale=".concat(locale),
      children: t(locale)
    })
  });
};

function Footer(_ref2) {
  var t = _ref2.t;

  var _useContext = Object(react["useContext"])(commonjs["I18nContext"]),
      language = _useContext.i18n.language;

  return /*#__PURE__*/Object(jsx_runtime["jsx"])("footer", {
    children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "footer-wrapper",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
          children: ["Designed with \xA0", /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
            icon: "heart"
          }), "\xA0 in Taiwan"]
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          className: "copyright",
          children: "\xA9 2020 CakeResume"
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "footer-wrapper",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "footer-link-wrapper",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
            href: routes["j" /* PRIVACY_POLICY_ROUTE_PATH */],
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              className: "footer-link",
              target: "_blank",
              children: t('privacy')
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
            href: routes["l" /* TERMS_OF_SERVICE_ROUTE_PATH */],
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              className: "footer-link",
              target: "_blank",
              children: t('termsOfService')
            })
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "footer-language-selector",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            className: "language",
            children: t('language')
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(esm_DropdownButton, {
            drop: "up",
            alignRight: true,
            variant: "default",
            title: t(language),
            className: "btn-group",
            id: "language-dropdown",
            children: share_language["a" /* LANGUAGES */].map(function (l) {
              return /*#__PURE__*/Object(jsx_runtime["jsx"])(Footer_LangItem, {
                locale: l,
                t: t
              }, l);
            })
          })]
        })]
      })]
    })
  });
}

/* harmony default export */ var components_Footer = __webpack_exports__["a"] = (Object(i18n["withTranslation"])('common')(Footer));

/***/ }),

/***/ "LbSa":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var React = __webpack_require__("q1tI");
var SpriteSymbol = __webpack_require__("4BeY");
var sprite = __webpack_require__("IaFt");

var symbol = new SpriteSymbol({
  "id": "slick_logo-b227c1bd--sprite",
  "use": "slick_logo-b227c1bd--sprite-usage",
  "viewBox": "0 0 82 34",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 82 34\" id=\"slick_logo-b227c1bd--sprite\"><g clip-path=\"url(#slick_logo-b227c1bd--sprite_clip0)\" fill=\"#434F4A\"><path d=\"M18.867 7.438l-3.732 2.217c-.697-1.214-1.362-2.006-1.994-2.376-.658-.422-1.507-.634-2.547-.634-1.277 0-2.337.364-3.18 1.09-.842.712-1.263 1.61-1.263 2.693 0 1.491 1.106 2.693 3.317 3.604l3.041 1.247c2.475 1.003 4.285 2.231 5.43 3.683 1.145 1.44 1.718 3.208 1.718 5.307 0 2.812-.935 5.136-2.804 6.97-1.882 1.849-4.219 2.773-7.01 2.773-2.645 0-4.83-.786-6.555-2.357C1.59 30.085.531 27.873.11 25.022l4.66-1.03c.21 1.795.58 3.036 1.106 3.723.948 1.32 2.33 1.98 4.146 1.98 1.435 0 2.626-.482 3.574-1.446.948-.963 1.422-2.184 1.422-3.663 0-.594-.086-1.135-.257-1.624a3.813 3.813 0 00-.77-1.366c-.342-.422-.79-.812-1.343-1.168-.553-.37-1.21-.72-1.974-1.05L7.73 18.15c-4.173-1.768-6.26-4.356-6.26-7.762 0-2.297.876-4.218 2.627-5.762 1.75-1.558 3.929-2.337 6.535-2.337 3.515 0 6.26 1.716 8.234 5.149zM28.799.012v33.445h-4.443V.012h4.443zM38.868 14.17v19.287h-4.442V14.17h4.442zm-5.114-8.02c0-.779.283-1.452.85-2.02a2.77 2.77 0 012.033-.851c.803 0 1.487.284 2.053.852.567.554.85 1.234.85 2.04a2.81 2.81 0 01-.85 2.059c-.552.567-1.23.851-2.033.851a2.793 2.793 0 01-2.054-.851c-.566-.568-.849-1.261-.849-2.08zm25.708 8.852v5.92c-1.013-1.24-1.922-2.092-2.725-2.554-.79-.475-1.717-.713-2.784-.713-1.671 0-3.06.588-4.166 1.763-1.105 1.175-1.658 2.646-1.658 4.416 0 1.808.533 3.293 1.6 4.455 1.078 1.162 2.454 1.742 4.126 1.742 1.066 0 2.007-.23 2.823-.692.79-.45 1.718-1.32 2.784-2.614v5.88c-1.803.938-3.607 1.407-5.41 1.407-2.975 0-5.463-.964-7.463-2.891-2.001-1.941-3.002-4.35-3.002-7.228s1.014-5.307 3.041-7.287c2.027-1.98 4.515-2.97 7.464-2.97 1.895 0 3.685.455 5.37 1.366zM69.275.012v20.396l6.26-6.238h5.962l-8.352 8.1 8.965 11.187h-5.766l-6.358-8.138-.71.713v7.425h-4.443V.012h4.442z\" /></g><defs><clipPath id=\"slick_logo-b227c1bd--sprite_clip0\"><path fill=\"#fff\" d=\"M0 0h82v34H0z\" /></clipPath></defs></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;


/***/ }),

/***/ "NeM1":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service",
      function () {
        return __webpack_require__("6+s+");
      }
    ]);
  

/***/ }),

/***/ "Ogzj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("YFqc");
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7vrA");
/* harmony import */ var _share_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("85xM");
/* harmony import */ var _images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("LbSa");
/* harmony import */ var _images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _header_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("V2I+");
/* harmony import */ var _header_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_header_scss__WEBPACK_IMPORTED_MODULE_6__);







var Logo = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default.a.forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
      href = _ref.href;
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("a", {
    href: href,
    onClick: onClick,
    ref: ref,
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(_images_Landing_slick_logo_svg_sprite__WEBPACK_IMPORTED_MODULE_5___default.a, {
      width: "82",
      height: "34"
    })
  });
});

var Header = function Header() {
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("header", {
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(next_link__WEBPACK_IMPORTED_MODULE_2___default.a, {
        href: _share_routes__WEBPACK_IMPORTED_MODULE_4__[/* LANDING_ROUTE_PATH */ "h"],
        passHref: true,
        children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(Logo, {})
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "cWnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zLVn");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vUet");
/* harmony import */ var _SafeAnchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("dbZe");






var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
var Button = react__WEBPACK_IMPORTED_MODULE_3___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      size = _ref.size,
      active = _ref.active,
      className = _ref.className,
      block = _ref.block,
      type = _ref.type,
      as = _ref.as,
      props = Object(_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]);

  var prefix = Object(_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__[/* useBootstrapPrefix */ "a"])(bsPrefix, 'btn');
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, prefix, active && 'active', variant && prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);

  if (props.href) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_SafeAnchor__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      as: as,
      ref: ref,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes, props.disabled && 'disabled')
    }));
  }

  if (ref) {
    props.ref = ref;
  }

  if (type) {
    props.type = type;
  } else if (!as) {
    props.type = 'button';
  }

  var Component = as || 'button';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
    className: classes
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "dbZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("zLVn");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/SafeAnchor.js





function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */


var SafeAnchor = react_default.a.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'a' : _ref$as,
      disabled = _ref.disabled,
      onKeyDown = _ref.onKeyDown,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["as", "disabled", "onKeyDown"]);

  var handleClick = function handleClick(event) {
    var href = props.href,
        onClick = props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (isTrivialHref(props.href)) {
    props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
    // otherwise, the cursor incorrectly styled (except with role='button')

    props.href = props.href || '#';
  }

  if (disabled) {
    props.tabIndex = -1;
    props['aria-disabled'] = true;
  }

  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({
    ref: ref
  }, props, {
    onClick: handleClick,
    onKeyDown: esm_createChainedFunction(handleKeyDown, onKeyDown)
  }));
});
SafeAnchor.displayName = 'SafeAnchor';
/* harmony default export */ var esm_SafeAnchor = __webpack_exports__["a"] = (SafeAnchor);

/***/ }),

/***/ "hGi/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectDestructuringEmpty; });
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

/***/ })

},[["NeM1",0,1,8,2,3,5,7,10,13,4]]]);